export default function PrivacyPage() {
    return (
        <div data-testid="privacy-page" className="bg-zinc-50 min-h-screen">
            <div className="max-w-3xl mx-auto px-6 py-16">
                <p className="label-tiny">Juridisch</p>
                <h1 className="font-display text-5xl mt-2">Privacy Policy</h1>
                <p className="text-zinc-500 mt-2 text-sm">Laatste update: februari 2026 — GDPR compliant</p>

                <div className="mt-10 space-y-8 text-sm leading-relaxed text-zinc-700">
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">1. Verantwoordelijke</h2>
                        <p className="mt-3">VdS Design, Gentse baan 7, 9100 Sint-Niklaas — vdsdesign2020@gmail.com — verwerkt persoonsgegevens conform de Algemene Verordening Gegevensbescherming (GDPR/AVG).</p>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">2. Welke gegevens?</h2>
                        <ul className="mt-3 space-y-1 list-disc pl-5">
                            <li>Account: naam, email, gehasht wachtwoord</li>
                            <li>Bestelling: leveradres, telefoonnummer, betaalmethode keuze</li>
                            <li>Ontwerpen: door jou ge&uuml;ploade afbeeldingen en aangemaakte designs</li>
                            <li>Technisch: IP, browser, taal (anoniem, voor functionaliteit)</li>
                        </ul>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">3. Waarvoor?</h2>
                        <ul className="mt-3 space-y-1 list-disc pl-5">
                            <li>Verwerken van je bestelling en levering</li>
                            <li>Communicatie over je bestelling (status mails)</li>
                            <li>Wettelijke verplichtingen (boekhouding)</li>
                        </ul>
                        <p className="mt-3">Wij gebruiken je gegevens <strong>nooit</strong> voor marketing zonder expliciete opt-in.</p>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">4. Met wie delen wij?</h2>
                        <ul className="mt-3 space-y-1 list-disc pl-5">
                            <li>bpost: leveradres voor verzending</li>
                            <li>Gmail / Google: voor verzenden van bevestigingsmails</li>
                            <li>Niemand anders. Geen verkoop van data aan derden.</li>
                        </ul>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">5. Bewaartermijn</h2>
                        <p className="mt-3">Account gegevens: zolang je account actief is. Bestelgegevens: 7 jaar (wettelijke fiscale termijn). Geüploade ontwerpen: tot 90 dagen na laatste bestelling.</p>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">6. Jouw rechten</h2>
                        <p className="mt-3">Je hebt het recht op inzage, correctie, verwijdering, beperking, overdraagbaarheid en bezwaar. Stuur een email naar <strong>vdsdesign2020@gmail.com</strong> met je verzoek. We reageren binnen 30 dagen.</p>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">7. Cookies</h2>
                        <p className="mt-3">Wij gebruiken enkel <strong>functionele cookies</strong> (login sessie, winkelmandje). Geen tracking cookies, geen advertentie cookies, geen Google Analytics.</p>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">8. Klacht?</h2>
                        <p className="mt-3">Contacteer ons eerst. Niet tevreden? Je kan klacht indienen bij de Gegevensbeschermingsautoriteit (gegevensbeschermingsautoriteit.be).</p>
                    </section>
                </div>
            </div>
        </div>
    );
}
